module.exports = __webpack_public_path__ + "media/images/emoticons/run-936119a9bd92f77624a74b687f24094d.gif";